import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Translator from '%app/js/common/services/translator';
import logger from '%app/js/common/services/Logger';
import {
    COOKIE_SETTINGS_PORTAL_ID,
    COOKIE_SETTINGS_TRANSLATION_KEY,
} from '../../config/cookieSettingsPortal';

function CookieSettingsButton({ openAgreementCard, classes }) {
    const mountNode = document.getElementById(COOKIE_SETTINGS_PORTAL_ID);
    if (!mountNode) {
        logger.error(`Element with ID ${COOKIE_SETTINGS_PORTAL_ID} was not found in the DOM`);
        return null;
    }

    return (
        ReactDOM.createPortal(
            <button
                className={classes.button}
                type="button"
                onClick={() => openAgreementCard()}
            >
                {Translator.trans(COOKIE_SETTINGS_TRANSLATION_KEY)}
            </button>,
            mountNode,
        )
    );
}

CookieSettingsButton.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.string,
    }).isRequired,
    openAgreementCard: PropTypes.func.isRequired,
};

export default React.memo(CookieSettingsButton);
